export default "__VITE_ASSET__R6evb$RI__"